export default "__VITE_ASSET__CCGltH7L__"